import React from "react";

import { TextField } from "../../../../components";

const TextArea = React.memo(({ state, field, editState, dispatch }) => {
  const handleFieldChange = (value, name, key) => {
    dispatch({ type: "UPDATE_FIELD", payload: { value, name, key } });
  };

  return (
    <TextField
      multiline
      size="small"
      name={"field_additional_info"}
      label={"Additional Info"}
      value={state?.[field.field_name]?.field_additional_info}
      placeholder={"Enter additional info"}
      inputProps={{
        onChange: (e) =>
          handleFieldChange(
            e.target.value,
            field.field_name,
            "additional_info"
          ),
      }}
      disabled={!editState}
    />
  );
});
export default TextArea;
